import {Button} from 'platform/components';
import {HStack, Text} from 'platform/foundation';

import i18n from '@dms/i18n';

import {suffixTestId, type RequiredTestIdProps} from 'shared/web';

interface SelectAllHeaderProps extends RequiredTestIdProps {
  isAllSelected: boolean;
  onToggle: () => void;
}

export function SelectAllHeader(props: SelectAllHeaderProps) {
  return (
    <HStack justify="space-between" align="center">
      <Text size="small" color="secondary">
        {i18n.t('entity.order.documents.selectDocumentsDescription')}
      </Text>
      <Button
        variant="link"
        size="small"
        leftIcon="action/done_all"
        title={i18n.t(
          props.isAllSelected
            ? 'entity.order.documents.unselectAll'
            : 'entity.order.documents.selectAll'
        )}
        onClick={props.onToggle}
        data-testid={suffixTestId(props.isAllSelected ? 'unselectAll' : 'selectAll', props)}
      />
    </HStack>
  );
}
